import { render, staticRenderFns } from "./ModalFormEdit.vue?vue&type=template&id=6c63140a&scoped=true&"
import script from "./ModalFormEdit.vue?vue&type=script&lang=js&"
export * from "./ModalFormEdit.vue?vue&type=script&lang=js&"
import style0 from "./ModalFormEdit.vue?vue&type=style&index=0&id=6c63140a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c63140a",
  null
  
)

export default component.exports